import React from 'react'
import PropTypes from 'prop-types'

function Tab({ label, onClick, isActive }) {
  const handleClick = () => {
    onClick(label)
  }

  return (
    <li
      className={`flex flex-1 items-center relative z-0 bg-white 
    ${isActive && 'text-brand-red z-10'}
    `}
    >
      <button
        className={`py-1 sm:py-4 ${isActive &&
          'border-b-2 border-gray-200'} bg-white font-sans text-xl font-bold leading-snug tracking-wider uppercase sm:text-xl sm:leading-tight`}
        aria-label={label}
        style={{ outline: 'none' }}
        onClick={handleClick}
      >
        {label}
      </button>
    </li>
  )
}

Tab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Tab
